export default {
	core: {
		name: "Name",
		size: "Size",
		modified: "Modified",
		actions: "Actions",
		edit: "Edit",
		cut: "Cut",
		remove: "Remove",
		createFolder: "Create Folder",
		create: "Create",
		update: "Update",
		delete: "Delete",
		deleteText: "Are you sure you want to delete this? This action cannot be reverted.",
		confirmDelete: "Type 'DELETE' to confirm",
		cancel: "Cancel",
		fileDeleted: "File Deleted",
		fileUpdated: "File Updated",
		folderDeleted: "Folder Deleted",
		folderCreated: "Folder Created",
		provider: "Provider",
		privacyLevel: "Privacy Level",
		public: "Public",
		private: "Private",
		fileName: "File Name",
		save: "Save",
		searchFiles: "Search Files",
		searchTemplates: "Search Templates by ID, Name or logical ID",
		dragFilesHereOr: "Drag your files here or",
		selectFiles: "Select Files",
		status: "Status",
		selectMoreFiles: "Select more files",
		upload: "Upload",
		fileTypeError: "File type is not valid",
		fileSizeMustBeUnder: "File size must be under",
		authorizationError: "You are not authorized",
		generalError: "Oops, something went wrong!",
		folder: "Folder",
		file: "File",
		download: "Download",
		selectFile: "Select File",
		noFileSelected: "No File Selected",
		select: "Select",
		fileUpload: "File Upload",
		graphQlQuery: "GraphQl Query",
		showAdvanced: "Show Advanced",
		hideAdvanced: "Hide Advanced",
		customQuery: "Custom query has been selected",
		confirm: "Confirm",
		deselect: "Deselect",
		pleaseSelectImageFile: "Please select an image file"
	}
}
